import { countryList } from "constants/data";

// export const senders: string[] = process.env.REACT_APP_ACCOUNTS?.split(",") || [];

export const countries: string[] = countryList.map((it) => it.name);
